var exports = {
  "M": "ellipsisRow__KvcKmP",
};

module.exports = exports;
